import moment from 'moment';
import * as yup from 'yup';
import {
  DOB_FE_FORMAT,
  Relationship,
  RetirementAccountBeneficiaryDTO,
} from '../../AccountOpening.meta';

export const nullBeneficiaryInfo: RetirementAccountBeneficiaryDTO = {
  givenName: '',
  familyName: '',
  dateOfBirth: '',
  socialSecurityNumber: '',
  streetAddress: '',
  city: '',
  postalCode: '',
  relationship: null,
  state: null,
};

export const relationshipOpts = [
  {
    label: 'Spouse',
    value: Relationship.Spouse,
  },
  {
    label: 'Children',
    value: Relationship.Children,
  },
  {
    label: 'Grand children',
    value: Relationship.GrandChildren,
  },
  {
    label: 'Other',
    value: Relationship.Other,
  },
];

const relationshipValidation = yup
  .number()
  .nullable()
  .when('hasBeneficiary', {
    is: true,
    then: yup
      .number()
      .nullable()
      .required('Relationship is required'),
  });

const firstNameValidation = yup
  .string()
  .nullable()
  .when('hasBeneficiary', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('First name is required'),
  });

const lastNameValidation = yup
  .string()
  .nullable()
  .when('hasBeneficiary', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('Last name is required'),
  });

const dobValidation = yup
  .string()
  .nullable()
  .when('hasBeneficiary', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('Date of birth is required')
      // eslint-disable-next-line func-names
      .test('is-dob-valid', 'Date is not valid', function(value) {
        if (!value) {
          // Let the .required() test handle it
          return true;
        }
        const date = moment(value, DOB_FE_FORMAT);
        return date.isValid();
      }),
  });

const ssnValidation = yup
  .string()
  .nullable()
  .when('hasBeneficiary', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('SSN is required')
      // eslint-disable-next-line func-names
      .test('SSN-is-valid', 'You must enter a valid social security number', function(value) {
        if (!value) {
          // Let the .required() test handle it
          return true;
        }
        return !(value.replace(/-/g, '').length < 9);
      }),
  });

const addressValidation = yup
  .string()
  .nullable()
  .when('hasBeneficiary', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('Address is required'),
  });

const cityValidation = yup
  .string()
  .nullable()
  .when('hasBeneficiary', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('City is required'),
  });

export const stateValidation = yup
  .string()
  .nullable()
  .when('hasBeneficiary', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('State is required'),
  });

const zipValidation = yup
  .string()
  .nullable()
  .when('hasBeneficiary', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('Zip is required'),
  });

export const beneficiaryValidation = yup
  .object()
  .nullable()
  .shape({
    relationship: relationshipValidation,
    givenName: firstNameValidation,
    familyName: lastNameValidation,
    dateOfBirth: dobValidation,
    socialSecurityNumber: ssnValidation,
    streetAddress: addressValidation,
    city: cityValidation,
    state: stateValidation,
    postalCode: zipValidation,
  });
